import gameProjectConfig from '../mpgd.game.json';

import { resolveGameLocale } from './i18n/messages';
import { prepareLocale } from './i18n/translations';
import { renderEntryFailure } from './runtime/renderEntryFailure';
import { installTextSelectionPolicy, resolveTextSelectionMode } from './platform/textSelection';

try {
  installTextSelectionPolicy(
    resolveTextSelectionMode((gameProjectConfig as { readonly ui?: unknown }).ui),
  );

  if (__APP_TARGET__ === 'reddit') {
    await import('./platform/devvitEntrypoint');
  } else if (__APP_TARGET__ === 'browser' && __DEBUG_BUILD__ && new URLSearchParams(location.search).get('inline') === '1') {
    // Browser fixtures must not pull the Reddit SDK into other target builds, including staging.
    const { mountInlinePreview } = await import('./platform/inlinePreview');
    const { readPostLevel } = await import('./platform/levels');
    mountInlinePreview({
      mount: document.body,
      locale: await prepareLocale(resolveGameLocale()),
      loadLevel: readPostLevel,
      ...(__DEBUG_BUILD__ && new URLSearchParams(location.search).get('economy') === 'sandbox' && ['localhost', '127.0.0.1', '[::1]'].includes(location.hostname) ? { economy: (await import('./platform/sandboxEconomy')).createSandboxEconomy() } : {}),
      ...(__DEBUG_BUILD__ && new URLSearchParams(location.search).get('economy') === 'foundation' && ['localhost', '127.0.0.1', '[::1]'].includes(location.hostname) && __NEM_MULTIPLAYER_URL__ ? {
        economy: (await import('./platform/foundationEconomy')).createBrowserFoundationEconomy({
          async load({ key }) { const value = localStorage.getItem(`mpgd:${key}`); return value === null ? null : { value: JSON.parse(value) as unknown }; },
          async save({ key, value }) { localStorage.setItem(`mpgd:${key}`, JSON.stringify(value)); },
        }),
      } : {}),
      ...(__DEBUG_BUILD__ && new URLSearchParams(location.search).get('economy') === 'devvit' && ['localhost', '127.0.0.1', '[::1]'].includes(location.hostname) ? { economy: (await import('./platform/devvitEconomy')).createBrowserDevvitEconomy() } : {}),
      ...(__DEBUG_BUILD__ && new URLSearchParams(location.search).get('economy') === 'reddit-free' && ['localhost', '127.0.0.1', '[::1]'].includes(location.hostname) ? { economy: (await import('./platform/devvitFreeHelp')).createDevvitFreeHelp() } : {}),
      expand: async (_event, destination) => {
        const url = new URL(location.href);
        url.searchParams.delete('inline');
        if (destination === 'puzzles' || destination === 'remix') {
          url.searchParams.set('view', destination);
        } else {
          url.searchParams.delete('view');
        }
        location.assign(url.href);
      },
    });
  } else {
    await import('./main');
  }
} catch (error) {
  renderEntryFailure(error);
}

export {};
